export default {
  namespaced: true,

  state: {
    recordList: [],
    trackNoList: [],
  },

  actions: {
    // 获取记录列表
  },

  mutations: {
    // 保存记录列表
    updateRecordList(state, value) {
      state.recordList = value;
    },
    // 更新轨迹单号列表
    updateTrackNoList(state, value) {
      state.trackNoList = value;
    },
  },

  getters: {},
};
